import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";

const MainPoint = () => {
  // Parallax effect for background
  const { scrollY } = useScroll();
  const yBackground = useTransform(scrollY, [0, 500], [0, -50]);

  // Animation for button pulse
  const buttonVariants = {
    pulse: {
      scale: [1, 1.05, 1],
      transition: { repeat: Infinity, duration: 1.5 },
    },
  };

  return (
    <Box
      className="main-point-section"
      sx={{ py: 3, px: 3,  bgcolor: "background.default" }}
    >
      <motion.div
        className="main-point-background"
        style={{ y: yBackground }}
      />
      <Box
        sx={{
          maxWidth: "800px",
          mx: "auto",
          textAlign: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h1" color="text.primary" gutterBottom>
          Start a New Revenue Stream, Today!
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: "600px", mx: "auto" }}
          >
            AirKitchenz connects your idle kitchen with food entrepreneurs,
            turning downtime into passive income. List your kitchen in minutes!
          </Typography>
          <motion.div variants={buttonVariants} animate="pulse">
            <Button
              variant="contained"
              color="primary"
              size="large"
              href="/profile/add-kitchen"
              sx={{
                "&:hover": {
                  opacity: 1,
                },
                px: 4,
                py: 1.5,
              }}
            >
              List Your Kitchen Now
            </Button>
          </motion.div>
        </motion.div>
      </Box>
    </Box>
  );
};

export default MainPoint;
